import { createEvent } from './createEvent.js';
import { dispatchEvent } from './dispatchEvent.js';
import { isMouseEvent, isKeyboardEvent } from './eventMap.js';

function dispatchUIEvent(config, target, type, init, preventDefault = false) {
    if (isMouseEvent(type) || isKeyboardEvent(type)) {
        init = {
            ...init,
            ...config.system.getUIEventModifiers()
        };
    }
    const event = createEvent(type, target, init);
    return dispatchEvent(config, target, event, preventDefault);
}
function bindDispatchUIEvent(config) {
    return dispatchUIEvent.bind(undefined, config);
}

export { bindDispatchUIEvent, dispatchUIEvent };
